import type { Action } from '@ngrx/store';
import { createReducer, on } from '@ngrx/store';
import { UpdateCookieConsent, UpdateGoogleAnalyticsClientId, UpdateUserState } from '../action/user.action';
import type { UserState } from '../state/user.state';
import { initialUserState } from '../state/user.state';

const userReducer = createReducer(
  initialUserState,

  on(UpdateUserState, (state: UserState, { payload }) => ({ ...state, ...payload })),

  on(UpdateGoogleAnalyticsClientId, (state: UserState, { payload }) => ({ ...state, googleAnalyticClientId: payload.ga })),

  on(UpdateCookieConsent, (state: UserState, { payload }) => ({ ...state, cookieConsent: payload.cookieConsent })),

);

export function UserReducer(state: UserState, action: Action) {
  return userReducer(state, action);
}
